<template>

        <rkm-form
            v-if="model"
            ref="RkmForm"
            show-legend
        >

            <rkm-row>
                <rkm-col cols="8">
                    <rkm-form-input
                        :validations="validations.descricao"
                        label="Descrição"
                        v-model="model.descricao"
                        type="text"
                        uppercase
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-checkbox
                        :label="false"
                        v-model="model.bloqueado"
                        inline
                    >
                        Inativar
                    </rkm-form-checkbox>
                </rkm-col>
            </rkm-row>
        </rkm-form>
</template>
<script>

// Mixins.
import { error, repository, stringCase, object } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {
    computed: {
        validations() {
            return {
                descricao: { required: true, max: 100 },
            }
        },
    },
    created() {

        this.repositories.grupo = this.getConectaSusRepository('transportePaciente.grupo')

        this.load()
    },
    data: () => ({
        repositories: {
            grupo: null,
        },
        form: null,
        model: null,
    }),
    methods: {
        ...mapActions([ 'setLoading', 'unsetLoading' ]),
        convertBooleanToBinary: (valor) => valor ? 1 : 0,
        trataNull: (valor) => valor === undefined || valor == null ? null : valor,
        load() {
            this.setLoading()

            const request = this.id ?
                this.repositories.grupo.edit(this.id) :
                this.repositories.grupo.create()

            request
                .then(({ data }) => this.setData(data.form || null, data.model || null))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        setData(form, model) {
            if (form) {

                this.form = Object.assign(form)
            }

            if (model) {

                this.model = Object.assign(model)
                this.model.bloqueado = this.model.bloqueado == 1
            }
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid) {
                        this.setLoading()

                        const modelSnakeCase = this.prepareData()

                        const request = modelSnakeCase.id === undefined || modelSnakeCase.id === null ?
                            this.repositories.grupo.store(modelSnakeCase) :
                            this.repositories.grupo.update(modelSnakeCase.id, modelSnakeCase)

                        request
                            .then(response => {
                                this.showSaveNotification()
                                this.$emit('save', response)
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    }
                })
        },
        prepareData() {
            const grupo = this.clone(this.model)

            grupo.id = this.trataNull(grupo.id)
            grupo.bloqueado = this.convertBooleanToBinary(grupo.bloqueado)

            return this.camelObjectKeysToSnakeRecursive(grupo)
        },
    },
    mixins: [ error, repository, stringCase, object ],
    props: {
        id: { type: [Number], default: null }
    },
}
</script>